<template>
	<v-container class="none-fluid link">
		<banner>Curriculum Vitae</banner>
		<br />
		<div class="mx-auto ">
            <div>
                <div v-html="$sanitize(lastModified)"></div>
            </div>
            <iframe :src="link" style="width:920px; height:750px;" frameborder="0"></iframe>           <br>
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import {
	getCV
} from "../../service/about/cv";

export default {
	components: {
		Banner
	},
	data() {
		return {
			link: {},
			lastModified: ""
		};
	},
	mounted() {
		getCV()
			.then(cv => {
				this.link = cv.link;
                this.lastModified = cv.lastModified;
            })
			.catch(err => {
				console.error(err.message);
			});
		
	}
};
</script>

<style lang="scss">

</style>